import {create} from 'zustand'
// import {getClientCity} from 'ultra/configs/general';
// import {DEFAULT_CITY} from 'ultra/const/general';

function getFieldsFromProduct(product) {
  // triggered from shopping card
  if (product.id) {
    return product;
  }

  const {_uri, title, price, discount, thumbnail} = product
  // const city = getClientCity(window) || DEFAULT_CITY;

  return {
    id: product.did || product._did,
    _uri,
    title,
    price,
    // city,
    thumbnail,
    discount,
  }
}

function getFieldsFromShop(shop) {
  // triggered from shopping card so no need to be updated
  if (shop.id) {
    return shop;
  }

  if (!shop.partner || !shop.partner_config) return {}
  const result = {}

  const {orderForm, order, currency, priceSufix} = shop.partner_config;
  const title = shop.partner_title;

  result.partner = shop.partner.id;
  result.id = shop.partner.shop;

  if (title) result.title = title;
  if (currency) result.currency = currency;
  if (priceSufix) result.priceSufix = priceSufix;
  if (orderForm) result.orderForm = orderForm;
  if (order) result.order = order;

  if (shop.partner_city) result.city = shop.partner_city;
  if (shop.partner_link) result.link = shop.partner_link;

  return result;
}

export const useShoppingStore = create((set) => ({
  cart: JSON.parse(localStorage.getItem('cart')) || [],
  clearCard: () => set(() => {
    localStorage.setItem('cart', JSON.stringify([]))
    return {cart: []};
  }),
  addProduct: (product, shop) => set((state) => {
    const result = [...state.cart]
    result.push({
      product: getFieldsFromProduct(product),
      shop: getFieldsFromShop(shop)
    })
    // return {cart: state.cart}
    localStorage.setItem('cart', JSON.stringify(result))
    return {cart: result};
  }),
  removeShop: (storeId) => set((state) => {
    let cart = [...state.cart]
    const newCart = []
    cart.map((item) => {
      if (item.shop.id == storeId) return;
      newCart.push(item)
    })
    
    localStorage.setItem('cart', JSON.stringify(newCart))
    return {cart: newCart}
  }),
  removeProduct: (product) => set((state) => {
    let cart = [...state.cart]

    const id = product.did || product._did || product.id

    const productToRemoveIndex = cart.findIndex(i => ((i.product.id == id)))
    if (productToRemoveIndex > -1) {
      cart.splice(productToRemoveIndex, 1)
    }

    localStorage.setItem('cart', JSON.stringify(cart))
    return {cart}
  }),
  removeAllProduct: (product) => set((state) => {
    let cart = [...state.cart]

    const id = product.did || product._did || product.id

    const updatedCart = cart.filter(i => ((i.product.id !== id)))

    localStorage.setItem('cart', JSON.stringify(updatedCart))
    return {cart: updatedCart}
  }),
}))
